/**
 * TanStack Router: /workforce/departments
 *
 * This route file was auto-generated by the route generation script.
 * Component: WorkforceDepartmentsPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import WorkforceDepartmentsPage from '@/app/workforce/departments/page'

/**
 * Route: /workforce/departments
 * Layout: _auth (authenticated)
 * Component: WorkforceDepartmentsPage
 */
export const Route = createFileRoute('/_auth/workforce/departments/')({
  component: WorkforceDepartmentsPage,
})
